import {createContext, useContext, useMemo} from 'react';

import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {GemSettings, GemSettingsFeature, NonNullableFeaturesSettingsConfig} from 'app/utils/config/interface';

type GemSettingsContext = GemSettings | undefined;

export const gemSettingsContext = createContext<GemSettingsContext>(undefined);

export const useGemSettings = (): GemSettings => {
    const contextIsDefined = useContext(gemSettingsContext);
    if (!contextIsDefined) {
        throw new Error('createGemSettingsContext must be used within a Provider');
    }

    return contextIsDefined;
};

export function useGemSettingsFeature<T extends NonNullableFeaturesSettingsConfig>(featureName: GemSettingsFeature): T | undefined {
    const gemSettings = useGemSettings();
    return useMemo(() => getGemSettingsFeature<T>(gemSettings, featureName), [gemSettings, featureName]);
}

export const GemSettingsProvider = gemSettingsContext.Provider;
export const GemSettingsConsumer = gemSettingsContext.Consumer;
